module.exports = __webpack_public_path__ + "img/testimonial-joy-bowles.c5320b14.png";